import { Box, Button, Text } from '@factorialco/deprecated-design-system'

import { useNavigation } from 'modules/core/hooks/useNavigation'
import { track, trackingEvents } from 'modules/core/lib/Tracking'
import i18n from 'modules/core/lib/i18n'

import Step from './Step'

const BlankSlate = () => {
  const { navigation } = useNavigation()
  const route = navigation.settings.time_categories_settings.fullPath()

  return (
    <Box alignItems="center" gap="s40" minHeight="s400" justifyContent="center">
      <Box width="s400" gap="s4" textAlign="center" justifyContent="center" alignItems="center">
        <Text.Header2>
          {i18n.t('time_tracking.settings.custom_time_range_section.blank_slate.title')}
        </Text.Header2>
        <Text.Normal size="200">
          {i18n.t('time_tracking.settings.custom_time_range_section.blank_slate.description')}
        </Text.Normal>
      </Box>
      <Box flexDirection="row" gap="s24">
        <Step
          icon="add-tag"
          description={i18n.t(
            'time_tracking.settings.custom_time_range_section.blank_slate.first_description'
          )}
          showArrow
        />
        <Step
          icon="monety-bag"
          description={i18n.t(
            'time_tracking.settings.custom_time_range_section.blank_slate.second_description'
          )}
          showArrow
        />
        <Step
          icon="night"
          description={i18n.t(
            'time_tracking.settings.custom_time_range_section.blank_slate.third_description'
          )}
        />
      </Box>
      <Box paddingTop="s40">
        <Button.Router
          to={route}
          onClick={() => track(trackingEvents.timeTracking.goToCreateWorkTimeCategories)}
        >
          {i18n.t('time_tracking.settings.custom_time_range_section.blank_slate.button')}
        </Button.Router>
      </Box>
    </Box>
  )
}
export default BlankSlate
